import script from "./WksLearningScenarioModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WksLearningScenarioModal.vue?vue&type=script&setup=true&lang=ts"

import "./WksLearningScenarioModal.vue?vue&type=style&index=0&id=8309d32c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8309d32c"]])

export default __exports__